var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// useLoadSource.ts
// import useIndexDB from "@/hooks/useIndexDB";
import { convertHttpsToS3Url, isUrlExpired, objectToQueryString } from "@/utils";
import axiosHttp from '@/api';
export var getPresignedReferenceUrl = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, axiosHttp.get("/?".concat(objectToQueryString(__assign(__assign({}, payload), { action: 'get_references_presigned_url' }))))];
    });
}); };
export default (function (_a) {
    // const { getByIndex, add, update } = useIndexDB();
    var _b = _a.returnDefault, returnDefault = _b === void 0 ? false : _b;
    var getCachedUrl = function (key, value) { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getPresignedReferenceUrl({ s3_url: key })];
                case 1:
                    res = _b.sent();
                    if (!((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.presigned_url)) {
                        return [2 /*return*/, value && returnDefault ? value : null];
                    }
                    // try {
                    //     if (cached) {
                    //         await update({ id: cached.id, key, value: res.data.presigned_url });
                    //     } else {
                    //         await add({ key, value: res.data.presigned_url });
                    //     }
                    // } catch (error) {
                    //     // console.error("Error caching URL:", error);
                    // }
                    return [2 /*return*/, res.data.presigned_url];
            }
        });
    }); };
    var getSource = function (src) { return __awaiter(void 0, void 0, void 0, function () {
        var s3Url, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!src) {
                        return [2 /*return*/, returnDefault ? src : null];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    if (!src.startsWith('s3://')) return [3 /*break*/, 3];
                    return [4 /*yield*/, getCachedUrl(src)];
                case 2: return [2 /*return*/, _a.sent()];
                case 3:
                    if (!src.startsWith('http')) return [3 /*break*/, 5];
                    s3Url = convertHttpsToS3Url(src);
                    if (!s3Url) {
                        return [2 /*return*/, returnDefault ? src : null];
                    }
                    // Return original URL if it's not expired
                    if (!isUrlExpired(src)) {
                        return [2 /*return*/, src];
                    }
                    return [4 /*yield*/, getCachedUrl(s3Url, src)];
                case 4: return [2 /*return*/, _a.sent()];
                case 5: 
                // Return default for non-matching URLs
                return [2 /*return*/, returnDefault ? src : null];
                case 6:
                    error_1 = _a.sent();
                    console.error("Error in getSource:", error_1);
                    return [2 /*return*/, returnDefault ? src : null];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    return { getSource: getSource };
});
